import { ErrorButtonModel } from './error-button.model';

export interface ErrorModalOptionsModel {
  // titolo
  title: string;
  // messaggio dinamico
  message: string;
  // istruzioni per l'utente
  instructions?: string;
  // icona
  icon?: string;
  // id errore
  id?: string;
  // codice errore
  code?: string;
  // bottoni
  buttons?: ErrorButtonModel[];
}
